import clsx from "clsx";
import React from "react";
import { FieldPathValue, FieldValues, Path, RegisterOptions, UseFormRegister, Validate } from "react-hook-form";
import { BiCalendarAlt } from "react-icons/bi";

import { VALIDATION_MESSAGE } from "constants/validation";

const DatePicker = <T extends FieldValues>({
  name,
  register,
  required,
  requiredMessage,
  isDisabled = false,
  isError = false,
  minDate,
  validateOption,
}: {
  name: Path<T>;
  register: UseFormRegister<T>;
  required: boolean;
  requiredMessage?: string;
  isDisabled?: boolean;
  isError?: boolean;
  minDate?: string;
  validateOption?: Validate<FieldPathValue<T, Path<T>>, T> | Record<string, Validate<FieldPathValue<T, Path<T>>, T>>;
}) => {
  const colorClasses = isDisabled
    ? "!bg-form-disabledBackground text-gray !border-gray cursor-not-allowed"
    : isError
    ? "bg-[#fdf2e1] border-attention"
    : "bg-input-normal border-input-normal";

  const requiredOptions: RegisterOptions<T, Path<T>> | undefined = required
    ? { required: requiredMessage || VALIDATION_MESSAGE.REQUIRED }
    : {};

  const validateOptions: RegisterOptions<T, Path<T>> | undefined = validateOption
    ? { ...requiredOptions, validate: validateOption }
    : { ...requiredOptions };

  return (
    <div
      className={`relative w-[200px] cursor-pointer overflow-hidden rounded border border-input-normal bg-input-normal hover:border-black focus:shadow-input ${
        isDisabled ? "!cursor-not-allowed !border-gray" : ""
      }`}
    >
      <input
        {...register(name, validateOptions)}
        type="date"
        min={minDate}
        className={clsx("picker flex h-12 w-full bg-input-normal pl-6 outline-none", colorClasses)}
        disabled={isDisabled}
        placeholder="hello"
      />
      <BiCalendarAlt className="absolute right-[15px] top-[16px]" fill="gray" />
    </div>
  );
};

export default DatePicker;
